import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBlcz366Bi-lhDtZjXOSN9JbFR9HJqLOF0",
    authDomain: "innovathrive-95773.firebaseapp.com",
    projectId: "innovathrive-95773",
    storageBucket: "innovathrive-95773.appspot.com",
    messagingSenderId: "144503491454",
    appId: "1:144503491454:web:4da5f1db2ca66ed64e812f",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
